/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withStore } from 'fierry/react';

import { readStorage, writeStorage } from 'solis/preferences/storage';


const getInitialState = () =>
{
  return readStorage();
};


const setPreferences = (state, preferences) =>
{
  return writeStorage({ ...state, ...preferences });
};


export default withStore(getInitialState, { setPreferences });
